// @flow
import React from 'react';
import styled from 'styled-components';

import { TYPE_SCALE_F1, TYPE_SCALE_F3 } from 'styles/type-scale';
import { FONT_WEIGHT_700, FONT_WEIGHT_100 } from 'styles/font-weight';
import { SPACING_MEDIUM } from 'styles/spacing';
import { CLARK_SECONDARY, CLARK_ACCENT_PRIMARY } from 'styles/colors';

const SectionHeader = ({ headline, subHeadline, textAlign = 'left', icon }: any) => (
  <Header textAlign={textAlign}>
    {icon && <Icon>{icon}</Icon>}
    <Headline>{headline}</Headline>
    {subHeadline && <Subheadline>{subHeadline}</Subheadline>}
  </Header>
);

export default SectionHeader;

const Header = styled.header`
  text-align: ${props => props.textAlign};
  padding: ${SPACING_MEDIUM} 0;
`;

const Icon = styled.div`
  color: ${CLARK_ACCENT_PRIMARY};
  margin: 0 auto;
  width: 50px;
`;

const Headline = styled.h1`
  ${TYPE_SCALE_F1};
  ${FONT_WEIGHT_700};
  color: ${CLARK_SECONDARY};
  line-height: 1.25;
`;

const Subheadline = styled.p`
  ${TYPE_SCALE_F3};
  ${FONT_WEIGHT_100};
  color: ${CLARK_SECONDARY};
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/components/shared/section-header/index.js